export const environment = {
  production: true,
  firebase: {
    apiKey: 'AIzaSyBFfbGSnqpWjuuIpIFxIfdIqcqLZmxr4Fw',
    authDomain: 'testpush-616b4.firebaseapp.com',
    projectId: 'testpush-616b4',
    storageBucket: 'testpush-616b4.firebasestorage.app',
    messagingSenderId: '1080769602548',
    appId: '1:1080769602548:web:b8814edfdd089858030fa1',
    vapidKey: 'BNwgIzw5QrZ0tkL3VZxzleCPkEZ7HS6FlNbU4_MECxKm0nUTHKzM73n6mnniWpUBZuN35KoMhMUBfdNlJRQU1zU'
  },
  apiURL: 'https://api-dev.data1861.ru/',
  hmsAppId: '110718875',
  sentryDsn: 'https://1daa22cd53064da6acc05c2520bf8d69@sentry-dev.data1861.ru/3',
  environmentName: 'development',
  capacitor: {
    appId: 'com.graintrade.forwarder.dev',
    appName: 'Экспедитор Дата1861 Dev'
  }
};
